export enum AccountType {
  internal = 'internal',
  organisation = 'organisation',
  partner = 'partner',
}

export enum AccountStatus {
  pending = 'pending',
  active = 'active',
  removed = 'removed',
}

export enum RoleType {
  Internal = 'internal',
  Organisation = 'organisation',
  Partner = 'partner',
}

export type Role = {
  id: string
  name: string
}

export type Account = {
  id: string
  email: string
  fullName?: string | null
  preferredName?: string
  phoneNumber?: string
  verifiedAt?: string
  deletedAt?: string | null
  status: AccountStatus
  /** Account types this account resolves to, e.g. ['internal'] or ['internal', 'partner']. */
  type?: AccountType[]
  role: Role | null
  partnerId?: string | null
  organisationId?: string | null
  admin?: string | null
  password?: string
  ssoUser?: string | null
  twoFaSecretVerifiedAt?: string | null
  twoFaMandatory?: boolean | null
  validationSubmissionSourceId?: string | null
  redactedAt?: string | null
  createdAt: string
  updatedAt: string
}
